import Image from "next/image";
import logo from "../../../public/img/legends/legends-logo.png";

export function Hero() {
  return (
    <div className="mx-auto max-w-lg pt-4 pb-1 text-center md:pt-10 md:pb-4">
      <h1 className="mt-0.5 mb-0 md:-mt-2 md:mb-1">
        <div className="mx-auto w-80 max-w-[150px] md:max-w-[230px]">
          <Image
            src={logo}
            alt="Worpel Legends logo"
            layout="intrinsic"
            width={536}
            height={211}
          />
        </div>
      </h1>
      <h2 className="font-light uppercase text-worpel-blue md:text-xl">
        AFL Legend Guessing Game
      </h2>
    </div>
  );
}
